import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./AboutPage.css";
import templeImage from "../assets/temple.jpg";

const AboutIskconUjn = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="about-wrapper">
      {/* HERO SECTION */}
      <div
        className="hero-section"
        style={{
          backgroundImage: `url(${templeImage})`,
        }}
      >
        <div className="hero-content" data-aos="fade-left">
          <h1>Sri Sri RadhaMadanmohan Mandir</h1>
          <hr />
          <p>
            <strong>The International Society of Krishna Consciousness (ISKCON)</strong>, popularly known as the Hare Krishna Movement, was founded in 1966 by His Divine Grace A. C. Bhaktivedanta Swami Prabhupada. ISKCON is a worldwide association of devotees of Lord Krishna, the Supreme Personality of Godhead; its members consist of 10,000 temple devotees and <strong>250,000</strong> congregational devotees. Over four decades ISKCON has grown to comprise of over 350 temples, 60 rural communities, 50 schools and 60 restaurants. One of the main objectives of ISKCON is to promote the well being of society by teaching the science of Krishna consciousness according to Bhagavad-Gita and other timeless Vedic scriptures.
          </p>
        </div>
      </div>

      {/* SEVEN PURPOSES */}
      <section className="purpose-section">
        <h2 data-aos="zoom-in">Seven Purpose of ISKCON</h2>
        <p className="section-subtitle" data-aos="fade-up">
          When Srila Prabhupada first incorporated ISKCON in 1966, he gave it<br />
          seven purposes
        </p>
        <div className="purpose-list">
          {[
            "To systematically propagate spiritual knowledge to society at large and to educate all people in the techniques of spiritual life in order to check the imbalance of values in life and to achieve real unity and peace in the world.",
            "To propagate a consciousness of Krishna, as it is revealed in the Bhagavad-gita and the Srimad-Bhagavatam.",
            "To bring the members of the Society together with each other and nearer to Krishna, the prime entity, thus to develop the idea within the members, and humanity at large, that each soul is part and parcel of the quality of Godhead (Krishna).",
            "To teach and encourage the sankirtana movement, congregational chanting of the holy names of God as revealed in the teachings of Lord Sri Chaitanya Mahaprabhu.",
            "To erect for the members, and for society at large, a holy place of transcendental pastimes, dedicated to the personality of Krishna.",
            "To bring the members closer together for the purpose of teaching a simpler and more natural way of life.",
            "With a view towards achieving the aforementioned purposes, to publish and distribute periodicals, magazines, books and other writings."
          ].map((text, i) => (
            <div
              key={i}
              className="purpose-box"
              data-aos="fade-up"
              data-aos-delay={i * 100}
            >
              {i + 1}) {text}
            </div>
          ))}
        </div>
      </section>

      {/* FOUR REGULATIVE PRINCIPLES */}
      <section className="principles-section">
        <h2 data-aos="zoom-in">Four Regulative Principles</h2>
        <p className="section-subtitle" data-aos="fade-up">
          Bhaktivedanta Swami prescribed four regulative principles, in relation<br />
          to the four legs of dharma, as the basis of the spiritual life
        </p>
        <div className="principles-grid">
          {[
            { title: "No Meat Eating", image: "/images/meat.jpg" },
            { title: "No Intoxication", image: "/images/intoxication.jpg" },
            { title: "No Illicit Sex", image: "/images/illicit.jpg" },
            { title: "No Gambling", image: "/images/gambling.jpg" }
          ].map((item, i) => (
            <div
              className="principle-card"
              key={i}
              style={{ backgroundImage: `url(${item.image})` }}
              data-aos="fade-up"
              data-aos-delay={i * 10000}
            >
              <div className="overlay-text">{item.title}</div>
            </div>
          ))}
        </div>
      </section>
      <section className="dharma-section">
        <h2 data-aos="zoom-in-up">The Four Legs Of Dharma</h2>
        <div className="dharma-grid">
          {[
            { title: "Daya:", desc: "Mercy", color: "#fdf4e3" },
            { title: "Tapas:", desc: "Self-Control Or Austerity", color: "#e3f4f1" },
            { title: "Satyam:", desc: "Truthfulness", color: "#f3e8ff" },
            { title: "Śaucam:", desc: "Cleanliness Of Body And Mind", color: "#e9f3ff" },
          ].map((item, i) => (
            <div
              key={i}
              className="dharma-card glass-card"
              style={{ backgroundColor: item.color }}
              data-aos="zoom-in"
              data-aos-delay={i * 150}
            >
              <span className="dharma-title">{item.title}</span>
              <span className="dharma-desc">{item.desc}</span>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default AboutIskconUjn